import DeliveryStatuses from "./DeliveryStatuses";

const getDeliveryStatus = (appointment) => {
  if (appointment?.appointmentStatus === "COMPLETE") {
    return DeliveryStatuses.deliveryCompleted;
  }

  return DeliveryStatuses.deliveryNotScheduled;
};

export default getDeliveryStatus;
